import '@fontsource/dosis';
import CssBaseline from '@mui/material/CssBaseline';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { SnackbarProvider } from 'notistack';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './App.scss';
import { Footer } from './components/footer/Footer';
import { Header } from './components/header/Header';
import { Routing } from './routing/Routing';
import { useAppDispatch, useAppSelector } from './store/hooks';
import { getUserDataAction } from './store/user/UserActionCreators';
import { userSelector } from './store/user/UserSelectors';
import { light } from './theme/Theme';
import { SnackbarUtilsConfigurator } from './utils/SnackbarUtil';

export const App = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const userId = localStorage.getItem('userId');
  const user = useAppSelector(userSelector);

  useEffect(() => {
    if (userId && user.id === -1) {
      dispatch(getUserDataAction(userId));
    }
  }, [userId, user.id]);

  return (
    <ThemeProvider theme={light}>
      <div className='app-container'>
        <CssBaseline enableColorScheme={true} />
        <SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: 'center', vertical: 'top' }}>
          <SnackbarUtilsConfigurator />
          <Header />
          <div className='content'>
            <Routing />
          </div>
          {location.pathname === '/listings' ? <></> : <Footer />}
        </SnackbarProvider>
      </div>
    </ThemeProvider>
  );
};
